// NeuralBoot — the "ESTABLISHING NEURAL LINK" jack-in loader shown once right after
// sign-in under the cyberpunk theme (terminal log lines stream in + a decrypt bar).
// In the default theme it renders nothing and calls onDone immediately, so callers
// can always mount it and let it decide.
import { useEffect, useRef, useState } from "react";

const LINES = [
  "INITIALIZING TMC//CHAT NEURAL LINK",
  "HANDSHAKE @ 10.0.14.7 ......... OK",
  "DECRYPTING SESSION TOKEN ...... OK",
  "AUTH VERIFIED",
  "SYNCING CHANNELS ............. OK",
  "UPLINK STABLE — WELCOME OPERATOR",
];

export default function NeuralBoot({ onDone }) {
  const cyber = typeof document !== "undefined" && document.documentElement.dataset.theme === "cyberpunk";
  const [lines, setLines] = useState([]);
  const onDoneRef = useRef(onDone);
  onDoneRef.current = onDone;

  useEffect(() => {
    if (!cyber) { onDoneRef.current?.(); return; }
    const timers = [];
    LINES.forEach((ln, i) => timers.push(setTimeout(() => setLines((p) => [...p, ln]), 300 * (i + 1))));
    timers.push(setTimeout(() => onDoneRef.current?.(), 300 * LINES.length + 750));
    return () => timers.forEach(clearTimeout);
  }, [cyber]);

  if (!cyber) return null;
  const pct = Math.round((lines.length / LINES.length) * 100);
  return (
    <div className="neural-boot">
      <div className="neural-boot__inner">
        <div className="neural-boot__head">
          <span className="neural-boot__spin" aria-hidden />
          <div>
            <div className="neural-boot__title">ESTABLISHING NEURAL LINK</div>
            <div className="neural-boot__sub">TMC//CHAT · SECURE UPLINK</div>
          </div>
        </div>
        <div className="neural-boot__log">
          {lines.map((l, i) => (
            <div key={i} className="neural-boot__line"><span className="neural-boot__gt">›</span> {l}</div>
          ))}
          <div className="neural-boot__line"><span className="neural-boot__gt">›</span> <span className="neural-boot__caret" aria-hidden /></div>
        </div>
        <div className="neural-boot__bar"><div className="neural-boot__fill" style={{ width: pct + "%" }} /></div>
        <div className="neural-boot__pct"><span>DECRYPTING</span><span>{pct}%</span></div>
      </div>
    </div>
  );
}
